// import './all.css';
// import { useState, useEffect } from 'react';
// import { motion } from "framer-motion";


// export function All({ style }) {
//   const [layersCount, setLayersCount] = useState(2); // default for laptop/desktop

//   // Detect screen size
//   useEffect(() => {
//     const handleResize = () => {
//       const width = window.innerWidth;
//       if (width <= 1024) setLayersCount(3); // tablet & mobile
//       else setLayersCount(2); // laptop/desktop
//     };

//     handleResize(); // set initial layers
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const mostUsedTech = [
//     { name: "JAVA", img: "java.png" },
//     { name: "SPRING", img: "spring.png" },
//     { name: "REACT", img: "react.png" },
//     { name: "Maven", img: "Maven.png" },
//     { name: "JS", img: "javascript.png" },
//     { name: "GRADLE", img: "Gradle.png" },
//     { name: "C", img: "cplus.png" },
//     { name: "KAFKA", img: "kafka.png" },
//     { name: "JENKINS", img: "Jenkins.png" },
//     { name: "C++", img: "C.png" },
//     { name: "SQL", img: "SQLDeveloper.png" },
//     { name: "MUI", img: "mui.png" },
//     { name: "ORACLE", img: "Oracle.png" },
//     { name: "GITHUB", img: "github2.png" },
//   ];

//   const experiencedTech = [
//     { name: "SPRING", img: "spring.png" },
//     { name: "REACT", img: "react.png" },
//     { name: "JAVA", img: "java.png" },
//     { name: "JS", img: "javascript.png" },
//     { name: "GIT", img: "git.png" },
//     { name: "SQL", img: "SQLDeveloper.png" },
//     { name: "ORACLE", img: "Oracle.png" },
//     { name: "HTML", img: "html.png" },
//     { name: "CSS", img: "css.png" },
//     { name: "CANVA", img: "canva.png" },
//     { name: "SPLINE", img: "spiline.png" },
//     { name: "JUNIT", img: "junit.png" },
//     { name: "ELK", img: "elk.png" },
//     { name: "REDIS", img: "redis.png" },
//   ];

//   const renderTechCards = (techArray) => {
//     const layerSize = Math.ceil(techArray.length / layersCount);
//     const layers = [];
//     for (let i = 0; i < layersCount; i++) {
//       const start = i * layerSize;
//       const end = start + layerSize;
//       const layerItems = techArray.slice(start, end);
//       if (layerItems.length > 0) {
//         layers.push(
//           <div className="exp-box1" key={i}>
//             {layerItems.map((tech, index) => (
//               <div className="ImgOfBoxTech" key={index}>
//                 <img src={tech.img} alt={tech.name} />
//                 <h5>{tech.name}</h5>
//               </div>
//             ))}
//           </div>
//         );
//       }
//     }
//     return layers;
//   };

//   return (
//     <div className={`container-fluid all-tech-page ${style}`}>
//       <div className="box1">
//         <div className="mb-3"><span>Most Used</span></div>
//         <div className="all-exp-card">
//           {renderTechCards(mostUsedTech)}
//         </div>
//       </div>
//       <div className="box2">
//         <div><span>Experienced</span></div>
//         <div className="all-exp-card">
//           {renderTechCards(experiencedTech)}
//         </div>
//       </div>
//     </div>
//   );
// }






import './all.css';
import { useState, useEffect } from 'react';
import { motion } from "framer-motion";

export function All({ style }) {
  const [layersCount, setLayersCount] = useState(2);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width <= 1024) setLayersCount(3);
      else setLayersCount(2);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const mostUsedTech = [
    { name: "JAVA", img: "java.png" },
    { name: "SPRING", img: "spring.png" },
    { name: "REACT", img: "react.png" },
    { name: "Maven", img: "Maven.png" },
    { name: "JS", img: "javascript.png" },
    { name: "GRADLE", img: "Gradle.png" },
    { name: "C", img: "cplus.png" },
    { name: "KAFKA", img: "kafka.png" },
    { name: "JENKINS", img: "Jenkins.png" },
    { name: "C++", img: "C.png" },
    { name: "SQL", img: "SQLDeveloper.png" },
    { name: "MUI", img: "mui.png" },
    { name: "ORACLE", img: "Oracle.png" },
    { name: "GITHUB", img: "github2.png" },
  ];

  const experiencedTech = [
    { name: "SPRING", img: "spring.png" },
    { name: "REACT", img: "react.png" },
    { name: "JAVA", img: "java.png" },
    { name: "JS", img: "javascript.png" },
    { name: "GIT", img: "git.png" },
    { name: "SQL", img: "SQLDeveloper.png" },
    { name: "ORACLE", img: "Oracle.png" },
    { name: "HTML", img: "html.png" },
    { name: "CSS", img: "css.png" },
    { name: "CANVA", img: "canva.png" },
    { name: "SPLINE", img: "spiline.png" },
    { name: "JUNIT", img: "junit.png" },
    { name: "ELK", img: "elk.png" },
    { name: "REDIS", img: "redis.png" },
  ];

  // Animation Variants 🎬
  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15, // each child delayed slightly
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
  };

  const renderTechCards = (techArray) => {
    const layerSize = Math.ceil(techArray.length / layersCount);
    const layers = [];
    for (let i = 0; i < layersCount; i++) {
      const start = i * layerSize;
      const end = start + layerSize;
      const layerItems = techArray.slice(start, end);
      if (layerItems.length > 0) {
        layers.push(
          <motion.div
            className="exp-box1"
            key={i}
            variants={containerVariants}
            initial="hidden"
            animate="show"
          >
            {layerItems.map((tech, index) => (
              <motion.div
                className="ImgOfBoxTech"
                key={index}
                variants={itemVariants}
              >
                <img src={tech.img} alt={tech.name} />
                <h5>{tech.name}</h5>
              </motion.div>
            ))}
          </motion.div>
        );
      }
    }
    return layers;
  };

  return (
    <div className={`container-fluid all-tech-page ${style}`}>
      <div className="box1">
        <div className="mb-3"><span>Most Used</span></div>
        <div className="all-exp-card">
          {renderTechCards(mostUsedTech)}
        </div>
      </div>
      <div className="box2">
        <div><span>Experienced</span></div>
        <div className="all-exp-card">
          {renderTechCards(experiencedTech)}
        </div>
      </div>
    </div>
  );
}
